import React from "react";
import "./style/Barann.css";

const Baran = () => {
  return (
    <div className="not-found-container">
      <h1 className="not-found-heading">404 - Page Not Found</h1>
      <p className="not-found-text">
        We're sorry, but the page you requested could not be found.
      </p>
      <p className="not-found-text">
        Return to <a href="/">homepage</a>.
      </p>
    </div>
  );
};

export default Baran;
